import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-c4ebc1c2")
const _hoisted_1 = { class: "skin-ul" }
const _hoisted_2 = ["onClick"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createBlock(_component_el_popover, {
    placement: "bottom",
    "show-arrow": false,
    width: 100,
    trigger: "click"
  }, {
    reference: _withCtx(() => [
      _createElementVNode("div", {
        class: "theme",
        style: _normalizeStyle({
          color: $setup.currentSkin.color,
        })
      }, _toDisplayString($setup.currentSkin.name), 5)
    ]),
    default: _withCtx(() => [
      _createElementVNode("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.skins, (item) => {
          return (_openBlock(), _createElementBlock("li", {
            key: item.id,
            onClick: ($event: any) => ($setup.clickSkin(item)),
            style: _normalizeStyle({
            color: item.color,
          })
          }, _toDisplayString(item.name), 13, _hoisted_2))
        }), 128))
      ])
    ]),
    _: 1
  }))
}